import { useCallback, useEffect, useMemo, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// uuid is a library for generating unique id
import { v4 as uuidv4 } from "uuid";

// @mui material components
import { Icon, Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../styles/Cost/CostSt.css"
// import Pagination from '@mui/material/Pagination';
import "../../../styles/Cost/CostSt.css";
import { useRecoilValue } from "recoil";
import { loginUser } from "atom/member/loginUser";
import SoftBadge from "../../../components/SoftBadge";


function CostTable({ columns, rows }) {
  const { light } = colors;
  const { size, fontWeightBold } = typography;
  const { borderWidth } = borders;
  const navigate = useNavigate();
  const user = useRecoilValue(loginUser);
  const location = useLocation();

  const renderColumns = columns.map(({ name, align, width }, key) => {
    let pl;
    let pr;

    if (key === 0) {
      pl = 3;
      pr = 3;
    } else if (key === columns.length - 1) {
      pl = 3;
      pr = 3;
    } else {
      pl = 1;
      pr = 1;
    }

    return (
      <SoftBox
        key={name}
        component="th"
        width="auto"
        pt={1.5}
        pb={1.25}
        pl={align === "left" ? pl : 3}
        pr={align === "right" ? pr : 3}
        textAlign={align}
        fontSize={size.xs}
        fontWeight={fontWeightBold}
        color="secondary"
        opacity={0.7}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        {name.toUpperCase()}
      </SoftBox>
    );
  });

  const renderRows = rows.map((row, key) => {
    const rowKey = `row-${key}`;
    const docNo = rows[key]["docNo"];

    // 비용처리 게시물 번호
    const listNo = 10 - key;

    const detailClick = () => {
      navigate(`/cost/${row.번호}`, { state: location.pathname })
    }

    const tableRow = columns.map(({ name, align, key }) => {
      let template;
      
      if (key === "approved_info") {
        template = (
          <SoftBox
            key={uuidv4()}
            component="td"
            p={1.5}
            textAlign={"center"}
            borderBottom={row.hasBorder ? `${borderWidth[1]} solid ${light.main}` : null}
          >
            <SoftBadge variant="contained" badgeContent={row[name]} color={row[name] === "결재완료" ? "success" : row[name] === "상신문서" ? "info" : row[name] === "임시보관" ? "secondary" : row[name] === "결재중" ? "dark" : "error"} size="ml" container />
          </SoftBox>
        );
      } else if (key === "cost_no"){
				template = (
					<SoftBox
					key={uuidv4()}
					component="td"
					p={1.5}
					textAlign={"center"}
					borderBottom={row.hasBorder ? `${borderWidth[1]} solid ${light.main}` : null}
					sx={{  width: "max-content" }}
					>
						<SoftTypography
							variant="button"
              fontWeight="regular"
							color="dark"
							sx={{ display: "inline-block", width: "max-content" }}
							>
							{listNo}
						</SoftTypography>
					</SoftBox>
				);
			} else {
        template = (
          <SoftBox
            key={uuidv4()}
            component="td"
            p={1}
            textAlign={align}
            borderBottom={row.hasBorder ? `${borderWidth[1]} solid ${light.main}` : null}
            onClick={detailClick}
          >
            <SoftTypography
              variant="button"
              fontWeight="regular"
              color="secondary"
              sx={{ display: "inline-block", width: "max-content" }}
            >
              {row[name]}
            </SoftTypography>
          </SoftBox>
        );
      }

      return template;
    });

    return <TableRow
      key={rowKey}
      className="costTableRowColor"
    >
      {tableRow}
    </TableRow>;
  });

  return (
    <TableContainer>
      <MuiTable>
        <SoftBox component="thead">
          <TableRow>{renderColumns}</TableRow>
        </SoftBox>
        <TableBody>{renderRows}</TableBody>
      </MuiTable>
    </TableContainer>
  )
}

// Setting default values for the props of Table
CostTable.defaultProps = {
  columns: [],
  rows: [{}],
};

// // Typechecking props for the Table
CostTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default CostTable;
